import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NoticeList.module.css';
import DataTable from '../../../components/common/DataTable';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function NoticeList() {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/admin/notice/history`, {
          params: { page: currentPage, size: pageSize },
        });

        if (response.data.code === 1) {
          const data = response.data.data;
          setNotices(data.items);
          const hasNext = data.pagination.hasNext;
          setTotalPages(hasNext ? currentPage + 1 : currentPage);
        } else {
          console.error("공지사항 불러오기 실패");
        }
      } catch(error) {
        console.error("공지사항 불러오기 중 오류 발생:", error);
      }
    };
    fetchNotices();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowClick = (notice) => {
    navigate(`/notices/${notice.noticeId}`);
  };

  const handleAddNotice = () => {
    navigate('/notices/create');
  };

  // 날짜 포매팅 함수
  // const formatDate = (dateString) => {
  //   if (!dateString) return '';
    
  //   try {
  //     const date = new Date(dateString);
  //     return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 형식으로 반환
  //   } catch (error) {
  //     console.error('날짜 형식 오류:', error);
  //     return dateString;
  //   }
  // };
  const formatDate = (dateString) => {
    if (!dateString) return '';
  
    try {
      const localDate = new Date(dateString); // UTC로 해석되어 9시간 차이 발생
      // KST 보정 (UTC+9)
      localDate.setHours(localDate.getHours() + 9);
      return localDate.toISOString().split('T')[0];
    } catch (error) {
      console.error('날짜 형식 오류:', error);
      return dateString;
    }
  };
  

  const columns = [
    {
      title: '순번',
      dataIndex: 'noticeId', // DB 스키마에 맞춤
      width: '60px'
    },
    {
      title: '제목',
      dataIndex: 'title',
      width: '500px'
    },
    {
      title: '생성일',
      dataIndex: 'updatedAt',
      width: '150px',
      render: (updatedAt) => formatDate(updatedAt) // 날짜 포매팅 적용
    },
    {
      title: '상세보기',
      dataIndex: 'noticeId', // DB 스키마에 맞춤
      width: '100px',
      render: (noticeId) => (
        <button
          className={styles.detailButton}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/notices/${noticeId}`);
          }}
        >
          상세보기
        </button>
      )
    }
  ];

  const ActionArea = () => (
    <div className={styles.actionArea}>
      <button onClick={handleAddNotice} className={styles.addButton}>
        추가하기 +
      </button>
    </div>
  );

  return (
    <div className={styles.container}>
      <DataTable
        columns={columns}
        data={notices}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
        actionButton={<ActionArea />}
      />
    </div>
  );
}